import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

const services = [
  {
    judul: 'Pool Maintenance Bali',
    detail:
      'Servicing all areas of Ubud, Bali, working closely with resort managers and body corporates on every aspect of managing your pool and spa.',
    link: '/jasa-maintenance-kolam-renang-bali',
  },
  {
    judul: 'Pool Water Testing Bali',
    detail:
      'Independent water testing. Our analysis reveals all, saving you time and money on chemicals and service.',
    link: '/jasa-testkit-air-kolam-bali',
  },
  {
    judul: 'Pool Chemicals Bali',
    detail:
      'Book a service or regular clean with our expert pool technicians and get your pool clean and back in balance.',
    link: '/jual-chemical-pool-bali',
  },
  {
    judul: 'Pool Equipment Bali',
    detail:
      'Repairs for commercial and residential pools. We troubleshoot problems on site to minimise equipment down time.',
    link: '/equipment-pool-bali',
  },
  {
    judul: 'Pool Expert Advice Bali',
    detail:
      'Professional advice on swimming pool treatment, ensuring your pool stays clean and safe year-round.',
    link: '/konsultasi-kolam-renang-bali',
  },
];

const ServiceRow = ({ s, i }) => (
  <div className="flex items-center justify-between gap-3 py-3">
    <div className="flex items-start gap-3">
      <span className="text-xl font-bold text-primary w-7 shrink-0 leading-tight">
        {String(i + 1).padStart(2, '0')}
      </span>
      <div>
        <h3 className="font-bold text-tertiary text-lg">{s.judul}</h3>
        <p className="text-gray-500 text-lg mt-0.5 leading-relaxed">
          {s.detail}
        </p>
      </div>
    </div>
    <Link
      to={s.link}
      aria-label={`Detail layanan ${s.judul} di Bali`}
      className="shrink-0 text-lg font-semibold text-tertiary border border-tertiary/30 hover:bg-primary hover:border-primary hover:text-white px-4 py-2.5 rounded-full transition min-h-[44px] flex items-center"
    >
      Detail
    </Link>
  </div>
);

const ServicesSection = () => {
  useEffect(() => {
    AOS.init({ once: false, mirror: true });
  }, []);

  return (
    <section id="services" className="py-10 px-4 sm:px-8 lg:px-20 bg-white">
      <div className="max-w-5xl mx-auto grid sm:grid-cols-2 gap-10 items-start">
        {/* Left block — title + intro + first 2 items */}
        <div data-aos="fade-right" data-aos-duration="700">
          <span className="inline-block text-xs font-semibold tracking-widest text-primary uppercase mb-3">
            Our Services
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-tertiary mb-4">
            Pool Services in Bali - Maintenance, Chemicals &amp; Equipment
          </h2>
          <p className="text-gray-500 text-lg leading-relaxed mb-4">
            From routine maintenance to water testing and equipment supply, we
            cover every aspect of pool care across Bali.
          </p>
          <div className="flex flex-col divide-y divide-gray-100">
            {services.slice(0, 2).map((s, i) => (
              <ServiceRow key={i} s={s} i={i} />
            ))}
          </div>
        </div>

        {/* Right block — remaining 3 items */}
        <div
          className="flex flex-col divide-y divide-gray-100 sm:mt-[132px]"
          data-aos="fade-left"
          data-aos-duration="700"
        >
          {services.slice(2).map((s, i) => (
            <ServiceRow key={i} s={s} i={i + 2} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
